var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 100,
  height: 100,
  viewBox: "0 0 100 100"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h100v100H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#D7D7D7",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M22 72V28h56v44H22zm4.831-4.926h20.742V32.921H26.831v34.153zm25.596 0h20.742V32.921H52.427v34.153z",
  mask: "url(#b)"
}))));
export default SvgPlaceholder;